import styled, { css } from 'styled-components';

export const Animated = styled.div`
    position: absolute;
    left: 0;
    width: 100%;
    z-index: 12;
    transition: 0.3s;
`;

export const Dropdown = styled.div`
    margin-top: 0;
    box-shadow: rgba(0, 0, 0, 0.05) 0px 2px 6px, rgba(0, 0, 0, 0.07) 0px 0px 0px 1px;
    background: rgb(255, 255, 255);
    border-radius: 3px;
    overflow: hidden;
    display: flex;
    width: 100%;
    text-align: left;
    height: 300px;
`;

export const DropdownMenu = styled.div`
    width: 100%;
    border-right: 1px solid #ddd;
    &:last-child {
        border-right: 0;
    }
`;

export const DropdownMenuItem = styled.div`
    padding: 7px 10px;
    color: #757575;
    transition: background-color 0.1s linear, color 0.1s linear;
    font-weight: 300;

    &:hover {
        background-color: #f1f1f1;
        color: #333;
        cursor: pointer;
    }

    ${(props) =>
        props.isSelected &&
        css`
            background: #f1f1f1;
            &:hover {
                color: #757575;
            }
        `};
`;

export const DropdownMenuVisitorGuide = styled.div`
    padding: 15px;
    color: #616161;
    font-weight: 300;
    border-bottom: 1px solid #ddd;
`;
